import React from 'react';
import PropTypes from 'prop-types';
import theme from '@app/theme';

function BaseIcon({ icon, size, customSize, color, onClick, className }) {
  const Icon = icon;

  let sizeInPx = theme.commons.icon.size[size];
  if (customSize) sizeInPx = `${customSize}px`;

  return (
    <Icon
      onClick={onClick}
      width={sizeInPx}
      height={sizeInPx}
      fill={theme.commons.icon.color[color]}
      viewBox="0 0 16 16"
      className={className}
    />
  );
}
BaseIcon.propTypes = {
  icon: PropTypes.func.isRequired,
  size: PropTypes.oneOf(Object.keys(theme.commons.icon.size)),
  customSize: PropTypes.number,
  color: PropTypes.oneOf(Object.keys(theme.commons.icon.color)),
  onClick: PropTypes.func,
  className: PropTypes.string,
};
BaseIcon.defaultProps = {
  size: 'small',
  color: 'default',
};
export default BaseIcon;
